import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { SvgIconComponent } from '../../../components';

@Component({
    selector: 'lib-success-state',
    standalone: true,
    imports: [CommonModule, SvgIconComponent],
    templateUrl: './success-state.component.html',
    styleUrl: './success-state.component.css'
})
export class SuccessStateComponent {
    @Input() title: string | undefined;
}
